/* Royal collection: inclusive exact ranges, checked against one real variant. */
(function () {
  'use strict';
  var names = ['rk_width_min', 'rk_width_max', 'rk_height_min', 'rk_height_max', 'rk_price_min', 'rk_price_max', 'rk_style', 'rk_color'];
  function numeric(value) {
    if (value === '' || value == null) return null;
    var n = Number(String(value).replace(',', '.'));
    return Number.isFinite(n) && n >= 0 ? n : null;
  }
  function inRange(value, min, max) {
    if (min == null && max == null) return true;
    return value != null && Number.isFinite(value) && (min == null || value >= min) && (max == null || value <= max);
  }
  function matchingVariants(product, state) {
    var metadata = product.metadata || {};
    if (state.rk_style && !(metadata.styles || []).includes(state.rk_style)) return [];
    if (state.rk_color && !(metadata.colors || []).includes(state.rk_color)) return [];
    return product.variants.filter(function (variant) {
      var dimensions = (metadata.dimensions || {})[variant.id] || {};
      // If the merchant changes a variant title, its old dimension mapping is
      // no longer authoritative. Its live price still participates normally.
      if (dimensions.title !== variant.title) dimensions = {};
      return inRange(dimensions.width, numeric(state.rk_width_min), numeric(state.rk_width_max)) &&
        inRange(dimensions.height, numeric(state.rk_height_min), numeric(state.rk_height_max)) &&
        inRange(variant.price / 100, numeric(state.rk_price_min), numeric(state.rk_price_max));
    });
  }
  function init(root) {
    if (root.dataset.rkFilterReady) return;
    root.dataset.rkFilterReady = 'true';
    var sort = root.querySelector('[data-rk-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.assign(url.href);
    });
    if (root.dataset.complete !== 'true' || root.dataset.filterEnabled !== 'true') return;
    var form = root.querySelector('[data-rk-filter-form]');
    if (!form) return;
    var text = JSON.parse(root.querySelector('[data-rk-filter-text]').textContent);
    var entries = Array.from(root.querySelectorAll('[data-rk-filter-product]')).map(function (el) {
      return { el: el, data: JSON.parse(el.querySelector('[data-rk-product-filter-data]').textContent), links: Array.from(el.querySelectorAll('a[href*="/products/"]')).map(function (a) { return { el: a, href: a.getAttribute('href') }; }) };
    });
    var dialog = root.querySelector('dialog');
    var opener = root.querySelector('[data-rk-filter-open]');
    var counter = root.querySelector('[data-rk-filter-count]');
    var applyButton = root.querySelector('[data-rk-filter-apply]');
    var chips = root.querySelector('[data-rk-filter-chips]');
    var error = root.querySelector('[data-rk-filter-error]');
    var empty = root.querySelector('[data-rk-filter-empty]');
    var media = matchMedia('(max-width: 899px)');
    var timer;
    ['style', 'color'].forEach(function (kind) {
      var known = new Set();
      entries.forEach(function (entry) { (entry.data.metadata[kind + 's'] || []).forEach(function (v) { known.add(v); }); });
      Object.keys(text[kind + 's']).forEach(function (key) {
        if (!known.has(key)) return;
        var option = document.createElement('option');
        option.value = key;
        option.textContent = text[kind + 's'][key];
        form.elements['rk_' + kind].appendChild(option);
      });
    });
    function readURL() {
      var params = new URL(location.href).searchParams;
      names.forEach(function (name) { form.elements[name].value = params.get(name) || ''; });
    }
    function stateFromForm() {
      var state = {};
      names.forEach(function (name) { state[name] = form.elements[name].value; });
      return state;
    }
    function close() {
      if (dialog.open) dialog.close();
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('rk-filters-open');
    }
    function chip(label, keys) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'rk-pfilters__chip';
      button.textContent = label + ' ×';
      button.setAttribute('aria-label', text.remove + ' ' + label);
      button.addEventListener('click', function () {
        keys.forEach(function (key) { form.elements[key].value = ''; });
        render(true);
        (media.matches ? opener : form.elements.rk_width_min).focus({ preventScroll: true });
      });
      chips.appendChild(button);
    }
    function render(updateURL) {
      var state = stateFromForm();
      var invalid = ['width', 'height', 'price'].some(function (kind) {
        var min = numeric(state['rk_' + kind + '_min']);
        var max = numeric(state['rk_' + kind + '_max']);
        return min != null && max != null && min > max;
      }) || !form.checkValidity();
      error.hidden = !invalid;
      applyButton.disabled = invalid;
      root.querySelectorAll('[data-rk-filter-reset]').forEach(function (button) { button.disabled = !names.some(function (name) { return state[name] !== ''; }); });
      if (invalid) return;
      var count = 0;
      var variantSelection = names.slice(0, 6).some(function (name) { return state[name] !== ''; });
      entries.forEach(function (entry) {
        var matches = matchingVariants(entry.data, state).sort(function (a, b) { return a.price - b.price; });
        var show = matches.length > 0;
        entry.el.hidden = !show;
        if (show) count++;
        var selected = show && variantSelection ? matches[0] : null;
        var note = entry.el.querySelector('[data-rk-filter-match]');
        note.hidden = !selected || entry.data.variants.length === 1;
        note.textContent = selected ? text.match + ' ' + (selected.title === 'Default Title' ? '' : selected.title + ' · ') + selected.money : '';
        entry.links.forEach(function (link) {
          if (!selected) { link.el.setAttribute('href', link.href); return; }
          var url = new URL(link.href, location.origin);
          url.searchParams.set('variant', selected.id);
          link.el.setAttribute('href', url.pathname + url.search + url.hash);
        });
      });
      var resultText = count === 1 ? text.count_one : text.count.replace('[count]', String(count));
      counter.textContent = resultText;
      applyButton.textContent = resultText + ' →';
      empty.hidden = count !== 0;
      chips.replaceChildren();
      ['width', 'height', 'price'].forEach(function (kind) {
        var a = state['rk_' + kind + '_min'];
        var b = state['rk_' + kind + '_max'];
        if (a || b) chip(text.labels[kind] + ': ' + (a || '0') + '–' + (b || '∞') + (kind === 'price' ? '' : ' cm'), ['rk_' + kind + '_min', 'rk_' + kind + '_max']);
      });
      ['style', 'color'].forEach(function (kind) {
        if (state['rk_' + kind]) chip(text[kind + 's'][state['rk_' + kind]], ['rk_' + kind]);
      });
      chips.hidden = !chips.children.length;
      root.querySelector('[data-rk-filter-badge]').textContent = chips.children.length ? '(' + chips.children.length + ')' : '';
      if (updateURL) {
        var url = new URL(location.href);
        names.forEach(function (name) { if (state[name]) url.searchParams.set(name, state[name]); else url.searchParams.delete(name); });
        url.searchParams.delete('page');
        history.replaceState(history.state, '', url.href);
      }
    }
    function reset() { names.forEach(function (name) { form.elements[name].value = ''; }); render(true); }
    root.querySelectorAll('[data-rk-filter-reset]').forEach(function (button) { button.addEventListener('click', function (e) { e.preventDefault(); reset(); }); });
    form.addEventListener('reset', function (e) { e.preventDefault(); reset(); });
    form.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { render(true); }, 160); });
    form.addEventListener('change', function () { clearTimeout(timer); render(true); });
    form.addEventListener('submit', function (e) { e.preventDefault(); render(true); if (!applyButton.disabled) close(); });
    opener.addEventListener('click', function () { dialog.showModal(); opener.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('rk-filters-open'); });
    root.querySelector('[data-rk-filter-close]').addEventListener('click', close);
    dialog.addEventListener('close', function () { opener.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('rk-filters-open'); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) { var r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); } });
    function layoutDialog() { close(); dialog.setAttribute('role', media.matches ? 'dialog' : 'group'); if (!media.matches) dialog.setAttribute('open', ''); }
    media.addEventListener('change', layoutDialog);
    window.addEventListener('popstate', function () { readURL(); render(false); });
    root.querySelector('[data-rk-filter-ui]').hidden = false;
    var fallback = root.querySelector('[data-rk-native-filters]');
    if (fallback) fallback.hidden = true;
    opener.hidden = false;
    layoutDialog();
    readURL();
    render(false);
    // Legacy server filters restrict Liquid's collection before client-side
    // filtering. Reload an unrestricted collection, preserving the new state,
    // so Reset can always reveal the full catalogue.
    var legacy = new URL(location.href);
    if (Array.from(legacy.searchParams.keys()).some(function (k) { return k.indexOf('filter.') === 0; })) {
      var oldMin = legacy.searchParams.get('filter.v.price.gte');
      var oldMax = legacy.searchParams.get('filter.v.price.lte');
      Array.from(legacy.searchParams.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) legacy.searchParams.delete(k); });
      if (oldMin && !legacy.searchParams.has('rk_price_min')) legacy.searchParams.set('rk_price_min', oldMin);
      if (oldMax && !legacy.searchParams.has('rk_price_max')) legacy.searchParams.set('rk_price_max', oldMax);
      location.replace(legacy.href);
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-rk-collection]').forEach(init); }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { numeric: numeric, inRange: inRange, matchingVariants: matchingVariants };
}());
